import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

/* Archive of report versions for the selected date+scope. A new version is created
   whenever the data basis changes (e.g., rollback + re-upload); older ones stay
   marked "Superseded" so everyone can see exactly what data each reflected. */
export const ReportVersions = ({ date, scopeKey }) => {
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    if (!date) return;
    api.get("/reports/daily/archive", { params: { date } })
      .then((r) => setVersions(r.data.versions.filter((v) => v.scope_key === scopeKey)))
      .catch((e) => console.error("Report archive fetch failed:", e));
  }, [date, scopeKey]);

  if (versions.length < 2) return null;
  return (
    <Card className="mt-5 max-w-[560px] mx-auto" data-testid="daily-report-versions">
      <div className="px-4 py-2.5 border-b bg-[hsl(var(--cx-surface))]">
        <p className="text-xs font-semibold uppercase tracking-[0.1em] text-[hsl(var(--cx-navy))]">
          Report versions — {dayjs(date).format("D MMM YYYY")}
        </p>
      </div>
      <div className="divide-y">
        {versions.map((v) => (
          <div key={v.id} className="px-4 py-2 flex items-center gap-3 text-xs" data-testid={`report-version-${v.version}`}>
            <Badge
              variant={v.status === "current" ? "default" : "outline"}
              className={v.status === "current"
                ? "bg-[hsl(var(--status-green))] text-white border-transparent"
                : "text-muted-foreground"}>
              {v.status === "current" ? "Current" : "Superseded"}
            </Badge>
            <span className="tabular">v{v.version}</span>
            <span className="text-muted-foreground tabular">Generated: {v.generated_on_fmt || "—"}</span>
            <span className="text-muted-foreground tabular ml-auto">Data: {v.based_on_fmt || "—"}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};
